// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconCopy = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 24 24' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M10.75 2a2.5 2.5 0 0 0-2.5 2.5v8.75c0 1.379 1.121 2.5 2.5 2.5h8.75c1.379 0 2.5-1.121 2.5-2.5V4.5C22 3.121 20.879 2 19.5 2zM4.5 8.25a2.5 2.5 0 0 0-2.5 2.5v8.75C2 20.879 3.121 22 4.5 22h8.75c1.379 0 2.5-1.121 2.5-2.5V17h-2.5v2.5H4.5v-8.75H7v-2.5z'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconCopy)
const Memo = memo(ForwardRef)
export default Memo
